export default {
      id: "btn-shape-usage",
      viewBox: "0 0 55 54",
      url: "../../assets/" + "sprite.svg#btn-shape-usage",
      toString: function () {
        return this.url;
      }
    }